import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { CloseIcon, PlusIcon } from '@xantory/icons';
import { styles } from './chip.styles';
import { useT } from '@xantory/i18n';
interface ChipProps {
  onRemove?: () => void;
  children: ComponentChildren;
}
export function Chip({
  onRemove,
  children
}: ChipProps) {
  const tc = useT('common');
  return <span {...stylex.props(styles.chip, onRemove == null && styles.chipStatic)}>
      {children}
      {onRemove != null && <button type="button" aria-label={tc('remove')} onClick={onRemove} {...stylex.props(styles.remove)}>
          <CloseIcon size={12} strokeWidth={2.5} />
        </button>}
    </span>;
}
interface AddChipProps {
  onClick?: () => void;
  children: ComponentChildren;
}
export function AddChip({
  onClick,
  children
}: AddChipProps) {
  return <button type="button" onClick={onClick} {...stylex.props(styles.addchip)}>
      <PlusIcon size={14} />
      {children}
    </button>;
}